import React from 'react';
import './Shimmer.css';

const FoodShimmer = () => {
  return (
    <div className="food-shimmer">
      <div className="food-shimmer-price"></div>
      <div className="food-shimmer-likes"></div>
      <div className="food-shimmer-description"></div>
      <div className="food-shimmer-restaurant"></div>
      <div className="food-shimmer-add-btn"></div>
    </div>
  );
};

export default FoodShimmer; 